var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-box"},[_c('video',{ref:"videoPlayer",attrs:{"poster":_vm.vimage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }